let routes = [{
    name: 'Department',
    icon: 'list_alt',
    path: '/department',
    permission: 'grade-create',
    service:true
}
];

export default routes;